// HTTP provides secure random bytes, but randomUUID and the async clipboard
// require HTTPS. Shared by Platform and sandboxed Controller documents.
(() => {
  if (typeof globalThis.crypto.randomUUID !== "function") {
    Object.defineProperty(globalThis.crypto, "randomUUID", { configurable: true, value: () => {
      const bytes = globalThis.crypto.getRandomValues(new Uint8Array(16));
      bytes[6] = (bytes[6] & 15) | 64;
      bytes[8] = (bytes[8] & 63) | 128;
      const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, "0")).join("");
      return `${hex.slice(0,8)}-${hex.slice(8,12)}-${hex.slice(12,16)}-${hex.slice(16,20)}-${hex.slice(20)}`;
    }});
  }
  if (typeof navigator !== "undefined" && !navigator.clipboard) {
    Object.defineProperty(navigator, "clipboard", { configurable: true, value: {
      writeText: async text => {
        const focused = document.activeElement;
        const input = document.createElement("textarea");
        input.value = String(text);
        input.setAttribute("readonly", "");
        input.style.cssText = "position:fixed;left:-9999px;top:0;opacity:0";
        document.body.append(input);
        try {
          input.select();
          if (!document.execCommand("copy")) throw new Error("Copy failed. Select the text and copy it manually.");
        } finally {
          input.remove();
          if (focused instanceof HTMLElement) focused.focus({preventScroll:true});
        }
      }
    }});
  }
})();
